import React, { useState } from 'react'
import styled from 'styled-components'
import { TopColorBar } from '../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen.jsx'
import { BackbuttonIcon } from '../shared/EntryHeader.jsx'
import backIconWhite from '../../assets/mobileFolderScreen/backIconWhite.png'
import Loader from '../Loader/Loader'
import LazyLoad from 'react-lazyload'
import pdf from '../../assets/mobileFolderScreen/pdf.png'
import { usePromiseTracker } from 'react-promise-tracker'

import ContactModal from './subComponents/ContactModal.jsx'
import BackButton from '../shared/BackButton.js'
import WatchEntryVideoDialog from './subComponents/WatchEntryVideoDialog.jsx'
import AfterTrainingPopup from './subComponents/AfterTrainingPopup.tsx'
import AfterCompleteMiazgaPopup from './subComponents/AfterCompleteMiazgaPopup.tsx'
import NotCompletedLockedTrainingPopup from './subComponents/NotCompletedLockedTrainingPopup.tsx'

import { fontSizeResponsive, mediaQ } from '../theme/mixins'

const MobileFolderScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const HeaderBar = styled(TopColorBar)`
  height: 6vh;
  position: relative;
  display: flex;
  align-items: center;
  font-family: 'Asap Condensed';
  padding: 0 20px;
  ${fontSizeResponsive(28)};
  font-weight: 500;
  font-stretch: condensed;
  font-style: normal;
  color: #ffffff;
  text-transform: uppercase;
  border: none;
  background-color: #9e0dfe;
  opacity: 1;
  width: ${(props) => (props.fullWidth ? '100vw' : 'unset')};
  background: rgb(254, 13, 159);
  background: linear-gradient(
    90deg,
    rgba(254, 13, 159, 1) 0%,
    rgba(250, 173, 2, 1) 100%
  );

  ${mediaQ('mobileAll', 'width: unset;')}
`

export const Backbutton = styled(BackbuttonIcon)`
  background: url(${backIconWhite});
  background-size: contain;
  background-repeat: no-repeat;
  border: none;
  margin-right: 20px;
`

const MainContentContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  flex-direction: column;
`

const FolderActionsRow = styled.div`
  display: none;
  width: 100%;
  justify-content: center;

  ${mediaQ('mobileAll', `display: flex;`)}
`

const ActionButton = styled.button`
  font-family: 'Asap Condensed';
  width: 90px;
  height: 40px;
  margin: 0 10px;
  ${fontSizeResponsive(28)};
  font-weight: 500;
  font-stretch: condensed;
  font-style: normal;
  color: #ffffff;
  text-transform: uppercase;
  border: none;
  background-color: #9e0dfe;

  &:nth-of-type(1) {
    opacity: ${(props) => (props.folderMode === 'video' ? '1' : '0.5')};
  }
  &:nth-of-type(2) {
    opacity: ${(props) => (props.folderMode === 'pdf' ? '1' : '0.5')};
  }
`
const DesktopScreen = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
const DesktopSection = styled.div`
  width: 50%;
  margin: 50px 0;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:nth-of-type(1) {
    border-right: 2px solid rgba(254, 13, 159, 0.2);
    ${mediaQ('mobileAll', 'border-right: none; margin: 10px 0;')}

    ${mediaQ('ipad12', 'width:80%')}
${mediaQ('ipad10', 'width:80%')}
${mediaQ('ipad9', 'width:80%')}
  }

  ${(props) =>
    props.folderMode === props.folder
      ? mediaQ('mobileAll', 'display: flex;')
      : mediaQ('mobileAll', 'display: none;')};

  ${mediaQ('mobileAll', 'width: 100%;')}
`

const DesktopSectionHeader = styled.div`
  width: unset;
  text-align: center;
  margin-bottom: 20px;
  display: flex;

  font-family: 'Asap Condensed';
  font-size: 40px;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  color: #fe0d9f;

  ${mediaQ('mobileAll', 'display: none;')}
`

const VideoContainer = styled.div`
  position: relative;
  display: flex;
  width: 85%;
  margin: 10px auto;
  transition: all 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
  border-radius: 6px;
  /* cursor: pointer; */
  border: 1px solid rgba(254, 13, 159, 0.1);
  box-shadow: 0 2.7px 7.6px -62px rgba(0, 0, 0, -0.03),
    0 6.5px 18.3px -62px rgba(0, 0, 0, -0.035),
    0 12.1px 34.4px -62px rgba(0, 0, 0, -0.027),
    0 21.7px 61.4px -62px rgba(0, 0, 0, -0.007),
    0 40.5px 114.9px -62px rgba(0, 0, 0, 0.031),
    0 97px 275px -62px rgba(0, 0, 0, 0.14);

  &:hover {
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
    ${(props) => (props.isDisabled ? null : 'transform: scale(1.07)')};
    ${(props) =>
      props.isDisabled
        ? null
        : `box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
      0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
      0 100px 80px rgba(0, 0, 0, 0.07)`};
    border: ${(props) =>
      props.isDisabled ? null : '1px solid rgba(254, 13, 159, 0.05)'};

    /* border: none; */
    /* margin: 21px 0; */
  }

  ${mediaQ(
    'mobileAll',
    `flex-direction:column; width:95%;margin: unset 0;max-height:200px;box-shadow:
  0 1.5px 2.3px -18px rgba(0, 0, 0, 0.02),
  0 3.7px 5.5px -18px rgba(0, 0, 0, 0.028),
  0 7px 10.4px -18px rgba(0, 0, 0, 0.035),
  0 12.5px 18.5px -18px rgba(0, 0, 0, 0.042),
  0 23.4px 34.7px -18px rgba(0, 0, 0, 0.05),
  0 56px 83px -18px rgba(0, 0, 0, 0.07);border: 1px solid rgba(0,0,0,0.05);`
  )}
`

const VideoInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  opacity: ${(props) => (props.isDisabled ? '0.3' : '1')};

  ${mediaQ('mobileAll', 'padding-bottom:10px;')}
`
const VideoName = styled.span`
  font-family: 'Asap';
  ${fontSizeResponsive(26)};
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: left;
  color: #fe0d9f;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 10px;
`

const VideoDuration = styled.span`
  font-family: 'Open Sans';
  ${fontSizeResponsive(21)};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #212121;
  margin-left: 20px;
  margin-top: 5px;
`

const VideoImage = styled.div`
  background: url(${(props) => props.imageSrc});
  background-size: 102% 102%;
  background-position: center;
  background-repeat: no-repeat;
  width: 300px;
  min-width: 300px;
  height: 180px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  opacity: ${(props) => (props.isDisabled ? '0.3' : '1')};
  ${mediaQ(
    'mobileAll',
    'width:100%;border-top-right-radius: 6px; border-bottom-right-radius: 6px; background-size:cover;'
  )}
`

export const DisabledBadge = styled.span`
  position: absolute;
  top: ${(props) => (props.nextTraining ? '50px' : '10px')};
  right: -10px;
  /* width: 20%;${(props) => (props.nextTraining ? '30%' : '20%')}; */
  padding: 3px 20px;
  height: 25px;
  font-family: 'Open Sans';
  font-size: ${(props) => (props.nextTraining ? '20px' : '16px')};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  /* line-height: 1.5; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  letter-spacing: normal;
  text-align: center;

  background-color: ${(props) =>
    props.watched
      ? 'rgba(250,173,2,1)'
      : props.nextTraining
      ? 'transparent'
      : '#fe0d9f'};
  color: ${(props) => (props.nextTraining ? '#fe0d9f' : 'white')};

  box-shadow: ${(props) =>
    !props.nextTraining
      ? `0 1.2px 0.8px rgba(0, 0, 0, 0.02),
    0 2.9px 2px rgba(0, 0, 0, 0.028), 0 5.4px 3.8px rgba(0, 0, 0, 0.035),
    0 9.6px 6.7px rgba(0, 0, 0, 0.042), 0 18px 12.5px rgba(0, 0, 0, 0.05),
    0 43px 30px rgba(0, 0, 0, 0.07)`
      : 'unset'};

  ${mediaQ('mobileAll', `right:10px; width:40%;font-size: 16px;`)}

  .next-training {
    ${mediaQ('mobileAll', `font-size:14px;`)}
  }
`

const LazyLoadInstance = styled(LazyLoad)`
  width: 100%;
`

const LazyLoadContainer = styled.div`
  width: 100%;
  margin: 0 auto;
`

const PdfContainer = styled.div`
  display: flex;
  align-self: baseline;
  margin-left: 30px;
  padding: 10px;
`
const PdfItem = styled.div`
  display: flex;
`
const PdfImage = styled.div`
  background: url(${pdf});
  background-size: 50%;
  background-position: center;
  background-repeat: no-repeat;
  width: 40px;
  height: 40px;
  padding: 20px;
  background-color: #e8e8e8;
`
const PdfActionButton = styled.a`
  font-family: 'Asap Condensed';
  border: none;
  background-color: transparent;
  width: fit-content;
  font-size: 16px;
  font-weight: 500;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.63;
  letter-spacing: normal;
  text-align: left;
  color: #212121;
  cursor: pointer;
  border: 1px solid transparent;
  transition: 0.3s ease-in-out;
  margin: 0;

  &:hover {
    transform: scale(1.05);

    font-weight: bold;
  }
`
const PdfName = styled.span`
  font-family: 'Asap Condensed';
  font-size: 20px;
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: left;
  color: #212121;
`
const PdfInfoRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`
const ContactButton = styled.button`
  width: initial;
  padding: 15px 35px;
  margin-left: 20px;
  position: absolute;

  font-family: 'Asap Condensed';
  ${fontSizeResponsive(24)};
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  border: none;
  background: linear-gradient(
    90deg,
    rgba(254, 13, 160, 1) 0%,
    rgba(250, 174, 1, 1) 100%
  );
  color: white;
  box-shadow: 0 2.5px 2.3px -11px rgba(0, 0, 0, 0.011),
    0 6.1px 5.5px -11px rgba(0, 0, 0, 0.016),
    0 11.4px 10.4px -11px rgba(0, 0, 0, 0.02),
    0 20.3px 18.5px -11px rgba(0, 0, 0, 0.024),
    0 38px 34.7px -11px rgba(0, 0, 0, 0.029),
    0 91px 83px -11px rgba(0, 0, 0, 0.04);

  transition: ease-in-out 0.35s all;

  &:hover {
    transform: scale(1.025);
    border: none;
  }

  ${mediaQ('mobileAll', 'position: relative; margin-bottom:20px;')}
`

export const SectionSubHeader = styled.div`
  font-family: 'Asap';
  font-size: ${fontSizeResponsive(22)};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 3.13;
  letter-spacing: normal;
  text-align: left;
  color: #9e0dfe;
  text-align: left;
  width: 85%;

  &.alt {
    color: white;
    font-size: ${fontSizeResponsive(32)};
  }
`

const MobileFolderScreen = ({
  checkIfItsFirstVideo,
  checkIfPrevVidIswatched,
  checkIfThisIsLockedVid,
  videos,
  openVideo,
  albumId,
  isLoading,
  folderName,
  pdfUrls,
  unlockAlgorithm,
  isWatchedAndLocked,
  showUnlockTime,
  renderNextTrainingBadge,
  folderContactEmail,
  shouldRenderDialog,
  temporaryCloseDialog,
  shouldPaidPackageVideoBeUnlocked,
  lastWatchedVideoFromThisFolder,
  nextTrainingToWatchOrder,
  toggleAfterTrainingPopupOpen,
  isAfterTrainingPopupOpen,
  isAfterCompleteMiazgaPopupOpen,
  toggleAfterCompleteMiazgaPopupOpen,
  userCurrentStage,
  isTodayWatchedVideo,
  todayWatchedVideo,
  userWatchedVideosFromThisFolder,
  isNotCompletedLockedTrainingPopupOpen,
  toggleNotCompletedLockedTrainingPopupOpen,
  todayLockedVideo,
  isLockedVideoToday,
  isThisPaidContentFolder,
  completedMiazgaTrainingName,
  isTodayTrainingDay,
}) => {
  const [folderMode, setFolderMode] = useState('video')
  const { promiseInProgress } = usePromiseTracker()

  const setActiveFolderMode = (mode) => {
    if (mode === 'video') {
      setFolderMode('video')
    } else {
      setFolderMode('pdf')
    }
  }
  const showCorrectTime = (vidTime) => {
    let correctTime
    if (vidTime < 60) {
      correctTime = 1
      return correctTime
    } else {
      correctTime = parseInt(vidTime / 60)
      return correctTime
    }
    return correctTime
  }

  const [modalIsOpen, setIsOpen] = React.useState(false)

  const openModal = () => {
    setIsOpen(true)
  }
  const closeModal = () => {
    setIsOpen(false)
  }

  const trainingForToday = () => {
    let result

    if (videos && videos.length) {
      result = videos.find((x) => !x.isAvailable)
    }

    if (videos && videos.length && result == undefined) {
      result =
        videos[videos.length - 1].isAvailable && videos[videos.length - 1]
    }

    return result && result.order
  }

  const completellyWatchedVideos = () => {
    let counter = 0
    if (userWatchedVideosFromThisFolder) {
      userWatchedVideosFromThisFolder.forEach(
        (status) => status.is_watched && counter++
      )
    }

    return counter
  }

  const trainingForTodayOrder =
    trainingForToday() == 0 ||
    completellyWatchedVideos() == (videos && videos.length)
      ? 0
      : videos[videos.length - 1].isAvailable
      ? trainingForToday()
      : trainingForToday() - 1

  const trainingForNextDayOrder = trainingForTodayOrder + 1

  return (
    <MobileFolderScreenContainer>
      <HeaderBar>
        <BackButton place={folderName} specialLocation={'/trening'} />
      </HeaderBar>
      <MainContentContainer>
        {folderContactEmail !== undefined && (
          <ContactButton onClick={openModal}>SKONTAKTUJ SIĘ</ContactButton>
        )}
        <ContactModal
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
          // afterOpenModal={afterOpenModal}
          folderContactEmail={folderContactEmail}
        />
        <FolderActionsRow>
          <ActionButton
            onClick={() => setActiveFolderMode('video')}
            folderMode={folderMode}
            action={'showVideos'}
          >
            wideo
          </ActionButton>
          <ActionButton
            onClick={() => setActiveFolderMode('pdf')}
            action={'showPdf'}
            folderMode={folderMode}
          >
            pdf
          </ActionButton>
        </FolderActionsRow>
        <DesktopScreen>
          <DesktopSection folderMode={folderMode} folder="video">
            <DesktopSectionHeader>Video</DesktopSectionHeader>

            {/* Today training section */}
            {((folderName && folderName.includes('MIAZGA')) ||
              isThisPaidContentFolder) &&
              videos &&
              completellyWatchedVideos() != (videos && videos.length) && (
                <>
                  <SectionSubHeader>Trening na dziś</SectionSubHeader>
                  <VideoContainer
                    onClick={() =>
                      unlockAlgorithm(
                        videos[trainingForTodayOrder],
                        trainingForTodayOrder
                      )
                        ? openVideo(
                            videos[trainingForTodayOrder].uri,
                            videos[trainingForTodayOrder].name,
                            trainingForTodayOrder
                          )
                        : null
                    }
                  >
                    <VideoImage
                      imageSrc={
                        videos &&
                        videos[trainingForTodayOrder && trainingForTodayOrder]
                          .pictures.sizes[3].link
                      }
                    ></VideoImage>
                    <VideoInfoContainer>
                      <VideoName>
                        {videos &&
                          videos[trainingForTodayOrder && trainingForTodayOrder]
                            .name}
                      </VideoName>
                      <VideoDuration>
                        {showCorrectTime(
                          videos &&
                            videos[
                              trainingForTodayOrder && trainingForTodayOrder
                            ].duration
                        )}{' '}
                        min
                      </VideoDuration>
                    </VideoInfoContainer>
                    {!unlockAlgorithm(
                      videos[trainingForTodayOrder && trainingForTodayOrder],
                      trainingForTodayOrder && trainingForTodayOrder
                    ) && <DisabledBadge>Niedostępny</DisabledBadge>}
                    {isWatchedAndLocked(
                      videos[trainingForTodayOrder && trainingForTodayOrder]
                    ) && <DisabledBadge watched>Obejrzany</DisabledBadge>}
                  </VideoContainer>
                </>
              )}

            {/* Next training section */}
            {completellyWatchedVideos() != videos.length &&
              (completellyWatchedVideos() != videos.length - 1 ||
                !isTodayTrainingDay) &&
              ((folderName && folderName.includes('MIAZGA')) ||
                isThisPaidContentFolder) && (
                <>
                  <SectionSubHeader>Trening na kolejny dzień</SectionSubHeader>
                  <VideoContainer
                  // onClick={() =>
                  //   openVideo(
                  //     videos[nextTrainingToWatchOrder + 1].uri,
                  //     videos[nextTrainingToWatchOrder + 1].name,
                  //     nextTrainingToWatchOrder
                  //   )
                  // }
                  >
                    <VideoImage
                      imageSrc={
                        videos[
                          trainingForNextDayOrder && trainingForNextDayOrder
                        ].pictures.sizes[3].link
                      }
                    ></VideoImage>
                    <VideoInfoContainer>
                      <VideoName>
                        {
                          videos[
                            trainingForNextDayOrder && trainingForNextDayOrder
                          ].name
                        }
                      </VideoName>
                      <VideoDuration>
                        {showCorrectTime(
                          videos[
                            trainingForNextDayOrder && trainingForNextDayOrder
                          ].duration
                        )}{' '}
                        min
                      </VideoDuration>
                    </VideoInfoContainer>
                    <DisabledBadge>Niedostępny</DisabledBadge>
                    {/* {!unlockAlgorithm(video, i) && (
                      <DisabledBadge>Niedostępny</DisabledBadge>
                    )}
                    {isWatchedAndLocked(video) && (
                      <DisabledBadge watched>Obejrzany</DisabledBadge>
                    )} */}
                    {showUnlockTime(
                      videos[
                        trainingForNextDayOrder && trainingForNextDayOrder
                      ],
                      trainingForNextDayOrder && trainingForNextDayOrder
                    ) &&
                      folderName &&
                      folderName.includes('MIAZGA') && (
                        <DisabledBadge className="next-training" nextTraining>
                          {renderNextTrainingBadge()}
                        </DisabledBadge>
                      )}
                  </VideoContainer>
                </>
              )}

            {videos.length > 0 && <SectionSubHeader>Treningi</SectionSubHeader>}
            {videos.map((video, i) => (
              <LazyLoadContainer key={video.resource_key}>
                <LazyLoadInstance height={250}>
                  <VideoContainer
                    onClick={() =>
                      unlockAlgorithm(video, i)
                        ? openVideo(video.uri, video.name, i)
                        : null
                    }
                  >
                    <VideoImage
                      imageSrc={video.pictures.sizes[3].link}
                    ></VideoImage>
                    <VideoInfoContainer>
                      <VideoName>{video.name}</VideoName>
                      <VideoDuration>
                        {showCorrectTime(video.duration)} min
                      </VideoDuration>
                    </VideoInfoContainer>

                    {!unlockAlgorithm(video, i) && (
                      <DisabledBadge>Niedostępny</DisabledBadge>
                    )}
                    {isWatchedAndLocked(video) && (
                      <DisabledBadge watched>Obejrzany</DisabledBadge>
                    )}
                    {showUnlockTime(video, i) &&
                      folderName &&
                      folderName.includes('MIAZGA') && (
                        <DisabledBadge className="next-training" nextTraining>
                          {renderNextTrainingBadge()}
                        </DisabledBadge>
                      )}
                  </VideoContainer>
                  {/* {checkIfPrevVidIswatched(i, video)} */}
                </LazyLoadInstance>
              </LazyLoadContainer>
            ))}
          </DesktopSection>
          <DesktopSection folder="pdf" folderMode={folderMode}>
            <DesktopSectionHeader>PDF</DesktopSectionHeader>
            {pdfUrls.length > 0 ? (
              pdfUrls.map((pdf) => (
                <PdfContainer>
                  <PdfItem>
                    <PdfImage />
                    <PdfInfoRow>
                      <PdfName>{pdf.name}</PdfName>
                      <PdfActionButton
                        href={pdf.url}
                        target="_blank"
                        download={`${pdf.name}`}
                      >
                        Zobacz
                      </PdfActionButton>
                    </PdfInfoRow>
                  </PdfItem>
                </PdfContainer>
              ))
            ) : (
              <VideoDuration>
                Ten album nie posiada żadnych plików pdf
              </VideoDuration>
            )}
          </DesktopSection>
        </DesktopScreen>
      </MainContentContainer>
      {promiseInProgress && <Loader />}
      {shouldRenderDialog && (
        <WatchEntryVideoDialog temporaryCloseDialog={temporaryCloseDialog} />
      )}
      <AfterTrainingPopup
        toggleAfterTrainingPopupOpen={toggleAfterTrainingPopupOpen}
        isAfterTrainingPopupOpen={isAfterTrainingPopupOpen}
        lastWatchedVideoFromThisFolder={lastWatchedVideoFromThisFolder}
        completedMiazgaTrainingName={completedMiazgaTrainingName}
      />
      <AfterCompleteMiazgaPopup
        isAfterCompleteMiazgaPopupOpen={isAfterCompleteMiazgaPopupOpen}
        toggleAfterCompleteMiazgaPopupOpen={toggleAfterCompleteMiazgaPopupOpen}
        userCurrentStage={userCurrentStage}
      />
      <NotCompletedLockedTrainingPopup
        isNotCompletedLockedTrainingPopupOpen={
          isNotCompletedLockedTrainingPopupOpen
        }
        toggleNotCompletedLockedTrainingPopupOpen={
          toggleNotCompletedLockedTrainingPopupOpen
        }
        todayLockedVideo={todayLockedVideo}
        isLockedVideoToday={isLockedVideoToday}
        albumId={albumId}
      />
    </MobileFolderScreenContainer>
  )
}

export default MobileFolderScreen
